import { NonQualifyingAdverb, QualifyingAdverb } from '../../types'
import нахуй from './нахуй'
import хуёво from './хуёво'
import нах from './нах'
import заебись from './заебись'
import охуенно from './охуенно'

const adverbs: Array<NonQualifyingAdverb | QualifyingAdverb> = [заебись, нах, нахуй, охуенно, хуёво]

export default adverbs
